import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Acasă", testid: "nav-link-home" },
  { to: "/servicii", label: "Servicii", testid: "nav-link-services" },
  { to: "/echipa", label: "Echipa", testid: "nav-link-team" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 900) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <nav className="navbar" data-testid="main-navbar">
      <div className="container-main navbar-inner">
        <Link to="/" onClick={() => setOpen(false)} data-testid="logo-link">
          <Logo />
        </Link>

        <button
          className={`hamburger ${open ? "open" : ""}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Meniu"
          data-testid="hamburger-btn"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`nav-links ${open ? "open" : ""}`} data-testid="nav-links">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={l.testid}
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
};
